// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-worker-update-toast_toast__ut3zS {
  position: fixed;
  right: clamp(14px, 3vw, 28px);
  bottom: clamp(14px, 3vw, 28px);
  z-index: 1800;
  width: min(380px, calc(100vw - 28px));
  min-height: 66px;
  padding: 10px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto 32px;
  align-items: center;
  gap: 10px;
  border: 1px solid rgba(255, 171, 0, 0.42);
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(11, 13, 19, 0.96), rgba(45, 29, 12, 0.94));
  color: #FFFFFF;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.42);
  backdrop-filter: blur(14px);
}

.service-worker-update-toast_copy__KPmsC {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-family: 'Inter', sans-serif;
}

.service-worker-update-toast_copy__KPmsC strong {
  font-size: 14px;
  line-height: 1.1;
  font-weight: 800;
}

.service-worker-update-toast_copy__KPmsC span {
  font-size: 12px;
  line-height: 1.25;
  color: rgba(255, 255, 255, 0.78);
}

.service-worker-update-toast_refreshButton__xAOeg,
.service-worker-update-toast_closeButton__Ui9Ej {
  border: none;
  border-radius: 8px;
  color: #FFFFFF;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  transition: transform 0.18s ease, filter 0.18s ease, background 0.18s ease;
}

.service-worker-update-toast_refreshButton__xAOeg {
  height: 36px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  background: linear-gradient(90deg, #DA2612 0%, #FFAB00 100%);
  font-size: 13px;
  font-weight: 800;
}

.service-worker-update-toast_refreshButton__xAOeg:disabled {
  cursor: wait;
  opacity: 0.72;
}

.service-worker-update-toast_closeButton__Ui9Ej {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  font-size: 13px;
}

.service-worker-update-toast_refreshButton__xAOeg:hover:not(:disabled),
.service-worker-update-toast_closeButton__Ui9Ej:hover {
  transform: translateY(-1px);
  filter: brightness(1.08);
}

.service-worker-update-toast_closeButton__Ui9Ej:hover {
  background: rgba(255, 255, 255, 0.18);
}

@media (max-width: 767px) {
  .service-worker-update-toast_toast__ut3zS {
    left: 12px;
    right: 12px;
    bottom: 12px;
    width: auto;
    grid-template-columns: minmax(0, 1fr) auto 30px;
    gap: 8px;
  }

  .service-worker-update-toast_refreshButton__xAOeg {
    min-width: 40px;
    width: 40px;
    padding: 0;
  }

  .service-worker-update-toast_refreshButton__xAOeg span {
    display: none;
  }

  .service-worker-update-toast_closeButton__Ui9Ej {
    width: 30px;
    height: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/service-worker-update-toast.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,6BAA6B;EAC7B,8BAA8B;EAC9B,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,kBAAkB;EAClB,mFAAmF;EACnF,cAAc;EACd,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,0EAA0E;AAC5E;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,WAAW;IACX,+CAA+C;IAC/C,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".toast {\n  position: fixed;\n  right: clamp(14px, 3vw, 28px);\n  bottom: clamp(14px, 3vw, 28px);\n  z-index: 1800;\n  width: min(380px, calc(100vw - 28px));\n  min-height: 66px;\n  padding: 10px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto 32px;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid rgba(255, 171, 0, 0.42);\n  border-radius: 8px;\n  background: linear-gradient(135deg, rgba(11, 13, 19, 0.96), rgba(45, 29, 12, 0.94));\n  color: #FFFFFF;\n  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.42);\n  backdrop-filter: blur(14px);\n}\n\n.copy {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-family: 'Inter', sans-serif;\n}\n\n.copy strong {\n  font-size: 14px;\n  line-height: 1.1;\n  font-weight: 800;\n}\n\n.copy span {\n  font-size: 12px;\n  line-height: 1.25;\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.refreshButton,\n.closeButton {\n  border: none;\n  border-radius: 8px;\n  color: #FFFFFF;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  transition: transform 0.18s ease, filter 0.18s ease, background 0.18s ease;\n}\n\n.refreshButton {\n  height: 36px;\n  padding: 0 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  background: linear-gradient(90deg, #DA2612 0%, #FFAB00 100%);\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.refreshButton:disabled {\n  cursor: wait;\n  opacity: 0.72;\n}\n\n.closeButton {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 13px;\n}\n\n.refreshButton:hover:not(:disabled),\n.closeButton:hover {\n  transform: translateY(-1px);\n  filter: brightness(1.08);\n}\n\n.closeButton:hover {\n  background: rgba(255, 255, 255, 0.18);\n}\n\n@media (max-width: 767px) {\n  .toast {\n    left: 12px;\n    right: 12px;\n    bottom: 12px;\n    width: auto;\n    grid-template-columns: minmax(0, 1fr) auto 30px;\n    gap: 8px;\n  }\n\n  .refreshButton {\n    min-width: 40px;\n    width: 40px;\n    padding: 0;\n  }\n\n  .refreshButton span {\n    display: none;\n  }\n\n  .closeButton {\n    width: 30px;\n    height: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toast": `service-worker-update-toast_toast__ut3zS`,
	"copy": `service-worker-update-toast_copy__KPmsC`,
	"refreshButton": `service-worker-update-toast_refreshButton__xAOeg`,
	"closeButton": `service-worker-update-toast_closeButton__Ui9Ej`
};
export default ___CSS_LOADER_EXPORT___;
